import React, { useState, useCallback } from "react";
import { Check, ChevronDown, X } from "react-feather";
import { FormattedDate, useIntl } from "react-intl";
import { formatPercent } from "./../../../utils/format";

const AreaCriteria = ({
  criteria,
  selectedCriteria,
  openCriteria,
  toggleCollapse
}) => {
  const [areaCollapsed, setAreaCollapsed] = useState(false);
  const { formatMessage } = useIntl();

  const hasAreaInfractions = useCallback(() => {
    if (!criteria) return false;
    return !!criteria.find(crit => !crit.conforme);
  }, [criteria]);

  return (
    <div className={`report-section${areaCollapsed ? " collapsed" : ""}`}>
      <h3 onClick={() => setAreaCollapsed(!areaCollapsed)}>
        <ChevronDown className="collapse-indicator" />{" "}
        {formatMessage({ id: "area" })}
        {hasAreaInfractions() ? (
          <X className="section-status-icon error" />
        ) : (
          <Check className="section-status-icon check" />
        )}
      </h3>

      {criteria.map(
        criterion =>
          selectedCriteria.includes(criterion.B3Criterio.id) && (
            <div
              className={`criteria-information${
                !openCriteria.includes(criterion.id) ? " collapsed" : ""
              }`}
              key={criterion.id}
            >
              <div
                className="criteria-title"
                onClick={() => toggleCollapse(criterion.id)}
              >
                <div className="text">
                  <div>
                    <ChevronDown size="18px" />
                  </div>
                  <div>{criterion.B3Criterio.nome}</div>
                </div>
                {criterion.status !== "processado" ? (
                  <div className="loader tiny"></div>
                ) : (
                  <div>
                    {!criterion.conforme ? (
                      <X className="error-icon" />
                    ) : (
                      <Check className="check-icon" />
                    )}
                  </div>
                )}
              </div>
              <div className="criteria-details">
                {criterion.B3Criterio.descricao && (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "descricao" })}:{" "}
                    </span>
                    {criterion.B3Criterio.descricao}
                  </div>
                )}
                {criterion.B3Criterio.fonte && (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "fonte" })}:{" "}
                    </span>
                    <a
                      href={criterion.B3Criterio.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {criterion.B3Criterio.fonte}
                    </a>
                  </div>
                )}
                {criterion.B3CriterioVersao && criterion.B3CriterioVersao.data && (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "data-base" })}:{" "}
                    </span>
                    <FormattedDate
                      value={new Date(criterion.B3CriterioVersao.data)}
                    />
                  </div>
                )}
                {criterion.detalhes_json &&
                  criterion.detalhes_json.data_consulta && (
                    <div>
                      <span className="bold">
                        {formatMessage({ id: "data-consulta" })}:{" "}
                      </span>
                      <FormattedDate
                        value={new Date(criterion.detalhes_json.data_consulta)}
                      />
                    </div>
                  )}
                {criterion.conforme ? (

                  <>
                    {criterion.B3Criterio.slug === 'identifica_car' ? (

                      <div className="infraction">
                        <div className="infraction">
                          <span className="bold">
                            {formatMessage({ id: "infracoes-encontradas" })}:
                          </span>
                        </div>
                        
                        {criterion.descricao &&
                      criterion.descricao.map((infraction, index) => (
                        <div key={index} className="infraction">
                          {infraction.length > 0 && (
                            <div>
                              <div className="status-icon">
                                
                              </div>
                              <div>
                                <span className="bold">
                                  {infraction[0].nome}:{" "}
                                </span>
                                {infraction[0].valor}
                              </div>
                            </div>
                          )}
                          {infraction.length > 1 &&
                            infraction.slice(1).map(detail => (
                              <p key={detail.nome}>
                                <span className="bold">{detail.nome}: </span>
                                {detail.valor}
                              </p>
                            ))}
                        </div>
                      ))}
                      </div>
                    ) : (
                      <div className="infraction">
                        <div>
                          <div className="status-icon">
                            <Check className="check-icon" size="16px" />
                          </div>
                          <span className="bold">
                            {formatMessage({ id: "nenhuma-infracao" })}
                          </span>
                        </div>
                      </div>
                    )}
                  </>

                  
                ) : (
                  <div>
                    {criterion.detalhes_json && criterion.detalhes_json.porcentagem_decimal !== null && (
                      <div className="infraction">
                        <span className="bold">
                          {formatMessage({ id: "porcentagem-sobreposicao" })}:{" "}
                        </span>
                        <span>
                          {formatPercent(criterion.detalhes_json.porcentagem_decimal)}
                        </span>
                      </div>
                    )}

                    <div className="infraction">
                      <span className="bold">
                        {formatMessage({ id: "infracoes-encontradas" })}:
                      </span>
                    </div>

                    {criterion.B3Criterio.slug === 'supressao_vegetacao_nativa' ? (() => {
                      let detalhes = [];
                      try {
                        const raw = criterion.detalhes_json && criterion.detalhes_json.detalhes_supressao;
                        detalhes = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
                      } catch (e) {
                        detalhes = [];
                      }

                      return detalhes.map((detalhe, index) => (
                        <div key={index} className="infraction">
                          <div>
                            <div className="status-icon">
                              <X className="error-icon" size="16px" />
                            </div>
                            <div>
                              <span className="bold">
                                {formatMessage({ id: "descricao" })}:{" "}
                              </span>
                              {detalhe.descricao}
                            </div>
                          </div>
                          <p>
                            <span className="bold">
                              {formatMessage({ id: "area-ha" })}:{" "}
                            </span>
                            {detalhe.area_ha}
                          </p>
                          <p>
                            <span className="bold">
                              {formatMessage({ id: "porcentagem-sobreposicao" })}:{" "}
                            </span>
                            {detalhe.porcentagem}
                          </p>
                        </div>
                      ));
                    })() : (
                      criterion.descricao &&
                        criterion.descricao.map((infraction, index) => (
                          <div key={index} className="infraction">
                            {infraction.length > 0 && (
                              <div>
                                <div className="status-icon">
                                  <X className="error-icon" size="16px" />
                                </div>
                                <div>
                                  <span className="bold">
                                    {infraction[0].nome}:{" "}
                                  </span>
                                  {infraction[0].valor}
                                </div>
                              </div>
                            )}
                            {infraction.length > 1 &&
                              infraction.slice(1).map(detail => (
                                <p key={detail.nome}>
                                  <span className="bold">{detail.nome}: </span>
                                  {detail.valor}
                                </p>
                              ))}
                          </div>
                        ))
                    )}
                  </div>
                )}
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default AreaCriteria;